import React from 'react';

interface ClassIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const ClassIcon: React.FC<ClassIconProps> = ({ 
  width = 15, 
  height = 11, 
  color = 'white' 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 15 11" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M14.3997 10.1003C14.6207 10.1003 14.7995 10.2791 14.7995 10.5C14.7995 10.7209 14.6207 10.8997 14.3997 10.8997H0.39974C0.178826 10.8997 0 10.7209 0 10.5C0 10.2791 0.178826 10.1003 0.39974 10.1003H14.3997Z" 
        fill={color}
      />
      <path 
        d="M11 10.5V9.83333C11 9.31787 10.5819 8.89974 10.0664 8.89974H8.23307C7.71761 8.89974 7.29948 9.31787 7.29948 9.83333V10.5C7.29948 10.7209 7.12065 10.8997 6.89974 10.8997C6.67883 10.8997 6.5 10.7209 6.5 10.5V9.83333C6.5 8.87604 7.27578 8.10026 8.23307 8.10026H10.0664C11.0237 8.10026 11.7995 8.87604 11.7995 9.83333V10.5C11.7995 10.7209 11.6207 10.8997 11.3997 10.8997C11.1788 10.8997 11 10.7209 11 10.5Z" 
        fill={color}
      />
      <path 
        d="M11 6.5V3.66667C11 3.1512 10.5819 2.73307 10.0664 2.73307H4.73307C4.21761 2.73307 3.79948 3.1512 3.79948 3.66667V10.5C3.79948 10.7209 3.62065 10.8997 3.39974 10.8997C3.17883 10.8997 3 10.7209 3 10.5V3.66667C3 2.70937 3.77578 1.93359 4.73307 1.93359H10.0664C11.0237 1.93359 11.7995 2.70937 11.7995 3.66667V6.5C11.7995 6.72091 11.6207 6.89974 11.3997 6.89974C11.1788 6.89974 11 6.72091 11 6.5Z" 
        fill={color}
      />
      <path 
        d="M13.0664 1.66667C13.0664 1.11438 12.6187 0.666667 12.0664 0.666667H2.73307C2.18079 0.666667 1.73307 1.11438 1.73307 1.66667V10.3333H1.06641V1.66667C1.06641 0.746192 1.8126 0 2.73307 0H12.0664C12.9869 0 13.7331 0.746192 13.7331 1.66667V10.3333H13.0664V1.66667Z" 
        fill={color}
      />
    </svg>
  );
};

export default ClassIcon;

